<template>
  <div class="page px-5">
    <page-layout>
      <h3
        slot="header"
        class="my-4 text-truncate"
      >
        <span class="d-none d-lg-inline">Manage</span>&nbsp;Clients
      </h3>
      <b-button
        slot="header"
        size="sm"
        variant="primary"
        @click="addClient()"
      >
        <i class="fa fa-plus" />
        <span class="d-none d-lg-inline-block">&nbsp; ADD CLIENT</span>
      </b-button>
      <client-list />
    </page-layout>
  </div>
</template>

<script>
import PageLayout from "@/components/shared/PageLayout.vue";
import ClientList from "@/components/tenants/clients/ClientList.vue";

export default {
  name: "Clients",
  components: {
    PageLayout,
    ClientList
  },
  methods: {
    addClient() {
      this.$router.push({
        path: `clients/new`
      });
    }
  }
};
</script>
